document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.mrk-popup-button').forEach(button => {
        button.addEventListener("click", function(event) {
            event.stopPropagation(); // Prevent the event from bubbling up to the document
            
            const popoverId = button.getAttribute('aria-controls');
            const popover = document.getElementById(popoverId);
            
            if (!popover) return; // If popover not found, exit the function
            
            const isExpanded = button.getAttribute("aria-expanded") === "true";
            
            // Close all dropdowns
            closeAllPopovers();
            
            if (!isExpanded) {
                // Show the popover
                popover.style.display = "block";
                popover.style.opacity = "1";
                popover.style.visibility = "visible";
                popover.setAttribute("open", "");
                button.setAttribute("aria-expanded", "true");
            }
        });
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener("click", function(event) {
        closeAllPopovers();
    });
    
    // Function to close all popovers
    function closeAllPopovers() {
        document.querySelectorAll('.mrk-popup-button').forEach(button => {
            const popoverId = button.getAttribute('aria-controls');
            const popover = document.getElementById(popoverId);
            
            if (popover && button.getAttribute("aria-expanded") === "true") {
                popover.style.display = "none";
                popover.style.opacity = "0";
                popover.style.visibility = "hidden";
                popover.removeAttribute("open");
                button.setAttribute("aria-expanded", "false");
            }
        });
    }
});
